import React from 'react';

const RouteComponent = React.lazy(() => import('.'));

export default {
  RouteComponent,
  path: '/:code/oidc/callback',
  name: 'oidcCallback',
};
